import './App.css';
import Header from './components/Header';
import TikBox from './components/TikBox';

function App() {
  return (
    <div className="App">
        <Header />
        <TikBox />
    </div>
  );
}

export default App;
